"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forEach = forEach;

/**
 * @module ol/geom/flat/segments
 */

/**
 * This function calls `callback` for each segment of the flat coordinates
 * array. If the callback returns a truthy value the function returns that
 * value immediately. Otherwise the function returns `false`.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {function(import("../../coordinate.js").Coordinate, import("../../coordinate.js").Coordinate): T} callback Function
 *     called for each segment.
 * @return {T|boolean} Value.
 * @template T
 */
function forEach(flatCoordinates, offset, end, stride, callback) {
  var ret;
  offset += stride;

  for (; offset < end; offset += stride) {
    ret = callback(flatCoordinates.slice(offset - stride, offset), flatCoordinates.slice(offset, offset + stride));

    if (ret) {
      return ret;
    }
  }

  return false;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSUE7Ozs7Ozs7Ozs7Ozs7QUFhTSxTQUFVQSxPQUFWLENBQWtCQyxlQUFsQixFQUFtQ0MsTUFBbkMsRUFBMkNDLEdBQTNDLEVBQWdEQyxNQUFoRCxFQUF3REMsUUFBeEQsRUFBZ0U7RUFDcEUsSUFBSUMsR0FBSjtFQUNBSixNQUFNLElBQUlFLE1BQVY7O0VBQ0EsT0FBT0YsTUFBTSxHQUFHQyxHQUFoQixFQUFxQkQsTUFBTSxJQUFJRSxNQUEvQixFQUF1QztJQUNyQ0UsR0FBRyxHQUFHRCxRQUFRLENBQ1pKLGVBQWUsQ0FBQ00sS0FBaEIsQ0FBc0JMLE1BQU0sR0FBR0UsTUFBL0IsRUFBdUNGLE1BQXZDLENBRFksRUFFWkQsZUFBZSxDQUFDTSxLQUFoQixDQUFzQkwsTUFBdEIsRUFBOEJBLE1BQU0sR0FBR0UsTUFBdkMsQ0FGWSxDQUFkOztJQUlBLElBQUlFLEdBQUosRUFBUztNQUNQLE9BQU9BLEdBQVA7SUFDRDtFQUNGOztFQUNELE9BQU8sS0FBUDtBQUNEIiwibmFtZXMiOlsiZm9yRWFjaCIsImZsYXRDb29yZGluYXRlcyIsIm9mZnNldCIsImVuZCIsInN0cmlkZSIsImNhbGxiYWNrIiwicmV0Iiwic2xpY2UiXSwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2dlb20vZmxhdC9zZWdtZW50cy5qcyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==